import React, { createContext } from "react";
import { type SocietyProfileInvoiceBodyInput } from "shared/api/types/society/[societyId]/profiles/[profileId]/accounting/invoice/index";
import { type InvoiceView } from "shared/mappers/database/accounting/invoice/invoice";
import { type InvoiceItemView } from "shared/mappers/database/accounting/invoice/invoice-item";
import { type ContentPageView } from "shared/mappers/database/content-page/content-page";
import { type SocietySettingHubPaymentTypes } from "shared/mappers/database/societySettingPublic/societySettingPublic";
import { type PaymentType } from "hub/src/pages/checkout/payment-form/HubCheckoutPaymentFormHelpers";
import { type HubCheckoutPaymentFormValues } from "hub/src/pages/CheckoutPage";
import { type HubRouteConfig } from "hub/src/routes/RouteConfigWrapper";

export type HubCheckoutPageRouteParams = {
  invoiceId: number;
  billingAddressType: string;
  billingAddressUse: string;
  shippingAddressType: string;
  shippingAddressUse: string;
  paymentProcessingModalTemplate?: string;
  profileUpdateRequiredTemplate?: string;
};

type HubCheckoutContextType = {
  invoice: InvoiceView | undefined;
  routeConfig: HubRouteConfig<HubCheckoutPageRouteParams>;
  optionalProductZone: ContentPageView;
  payButtonDisabled: boolean;
  paymentType: PaymentType;
  setPaymentType: (type: PaymentType) => void;
  hubPaymentTypes: SocietySettingHubPaymentTypes;
  checkoutError: string | undefined;
  setCheckoutError: (error: string | undefined) => void;
  editingInvoiceItem: InvoiceItemView | null;
  setEditingInvoiceItem: (item: InvoiceItemView | null) => void;
  invoiceIsLoading: boolean;
  setInvoiceIsLoading: (isLoading: boolean) => void;
  handleUpdateInvoice: (body: SocietyProfileInvoiceBodyInput) => Promise<void>;
  paymentFormValues: HubCheckoutPaymentFormValues;
  setPaymentFormValues: (values: HubCheckoutPaymentFormValues) => void;
  refetchInvoice: () => Promise<void>;
};
export const HubCheckoutContext = createContext<
  HubCheckoutContextType | undefined
>(undefined);

export const useHubCheckoutContext = () => {
  const context = React.useContext(HubCheckoutContext);
  if (!context) {
    throw new Error(
      "useHubCheckoutContext must be used within a HubCheckoutContextProvider",
    );
  }
  return context;
};
